/*
 * scripts.js - List out the ISO 15924 script codes and name mappings
 *
 * Copyright © 2022, 2025-2026 JEDLSoft
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// This file is auto-generated from ucd-full ScriptInfo.json
// Do not edit manually. Run "pnpm run generate:scripts" to regenerate.

export const iso15924 = {
    "scripts": [
        "Adlm",
        "Afak",
        "Aghb",
        "Ahom",
        "Arab",
        "Aran",
        "Armi",
        "Armn",
        "Avst",
        "Bali",
        "Bamu",
        "Bass",
        "Batk",
        "Beng",
        "Berf",
        "Bhks",
        "Blis",
        "Bopo",
        "Brah",
        "Brai",
        "Bugi",
        "Buhd",
        "Cakm",
        "Cans",
        "Cari",
        "Cham",
        "Cher",
        "Chis",
        "Chrs",
        "Cirt",
        "Copt",
        "Cpmn",
        "Cprt",
        "Cyrl",
        "Cyrs",
        "Deva",
        "Diak",
        "Dogr",
        "Dsrt",
        "Dupl",
        "Egyd",
        "Egyh",
        "Egyp",
        "Elba",
        "Elym",
        "Ethi",
        "Gara",
        "Geok",
        "Geor",
        "Glag",
        "Gong",
        "Gonm",
        "Goth",
        "Gran",
        "Grek",
        "Gujr",
        "Gukh",
        "Guru",
        "Hanb",
        "Hang",
        "Hani",
        "Hano",
        "Hans",
        "Hant",
        "Hatr",
        "Hebr",
        "Hira",
        "Hluw",
        "Hmng",
        "Hmnp",
        "Hntl",
        "Hrkt",
        "Hung",
        "Inds",
        "Ital",
        "Jamo",
        "Java",
        "Jpan",
        "Jurc",
        "Kali",
        "Kana",
        "Kawi",
        "Khar",
        "Khmr",
        "Khoj",
        "Kitl",
        "Kits",
        "Knda",
        "Kore",
        "Kpel",
        "Krai",
        "Kthi",
        "Lana",
        "Laoo",
        "Latf",
        "Latg",
        "Latn",
        "Leke",
        "Lepc",
        "Limb",
        "Lina",
        "Linb",
        "Lisu",
        "Loma",
        "Lyci",
        "Lydi",
        "Mahj",
        "Maka",
        "Mand",
        "Mani",
        "Marc",
        "Maya",
        "Medf",
        "Mend",
        "Merc",
        "Mero",
        "Mlym",
        "Modi",
        "Mong",
        "Moon",
        "Mroo",
        "Mtei",
        "Mult",
        "Mymr",
        "Nagm",
        "Nand",
        "Narb",
        "Nbat",
        "Newa",
        "Nkdb",
        "Nkgb",
        "Nkoo",
        "Nshu",
        "Ogam",
        "Olck",
        "Onao",
        "Orkh",
        "Orya",
        "Osge",
        "Osma",
        "Ougr",
        "Palm",
        "Pauc",
        "Pcun",
        "Pelm",
        "Perm",
        "Phag",
        "Phli",
        "Phlp",
        "Phlv",
        "Phnx",
        "Piqd",
        "Plrd",
        "Prti",
        "Psin",
        "Qaaa",
        "Qabx",
        "Ranj",
        "Rjng",
        "Rohg",
        "Roro",
        "Runr",
        "Samr",
        "Sara",
        "Sarb",
        "Saur",
        "Seal",
        "Sgnw",
        "Shaw",
        "Shrd",
        "Shui",
        "Sidd",
        "Sidt",
        "Sind",
        "Sinh",
        "Sogd",
        "Sogo",
        "Sora",
        "Soyo",
        "Sund",
        "Sunu",
        "Sylo",
        "Syrc",
        "Syre",
        "Syrj",
        "Syrn",
        "Tagb",
        "Takr",
        "Tale",
        "Talu",
        "Taml",
        "Tang",
        "Tavt",
        "Tayo",
        "Telu",
        "Teng",
        "Tfng",
        "Tglg",
        "Thaa",
        "Thai",
        "Tibt",
        "Tirh",
        "Tnsa",
        "Todr",
        "Tols",
        "Toto",
        "Tutg",
        "Ugar",
        "Vaii",
        "Visp",
        "Vith",
        "Wara",
        "Wcho",
        "Wole",
        "Xpeo",
        "Xsux",
        "Yezi",
        "Yiii",
        "Zanb",
        "Zinh",
        "Zmth",
        "Zsye",
        "Zsym",
        "Zxxx",
        "Zyyy",
        "Zzzz"
    ]
};

/**
 * Mapping from lowercase script names (as used in POSIX locale modifiers)
 * to ISO 15924 script codes.
 */
export const scriptNameToCode = {
    "adlam": "Adlm",
    "afaka": "Afak",
    "ahom": "Ahom",
    "alibata": "Tglg",
    "anatolianhieroglyphs": "Hluw",
    "ancientnortharabian": "Narb",
    "arabic": "Arab",
    "armenian": "Armn",
    "asomtavruliandnuskhuri": "Geok",
    "avestan": "Avst",
    "balinese": "Bali",
    "bamum": "Bamu",
    "bangla": "Beng",
    "bassavah": "Bass",
    "batak": "Batk",
    "baybayin": "Tglg",
    "bengali": "Beng",
    "berber": "Tfng",
    "beriaerfe": "Berf",
    "bhaiksuki": "Bhks",
    "blissymbols": "Blis",
    "bookpahlavi": "Phlv",
    "bopomofo": "Bopo",
    "brahmi": "Brah",
    "braille": "Brai",
    "buginese": "Bugi",
    "buhid": "Buhd",
    "burmese": "Mymr",
    "carian": "Cari",
    "caucasianalbanian": "Aghb",
    "chakma": "Cakm",
    "cham": "Cham",
    "cherokee": "Cher",
    "chisoi": "Chis",
    "chorasmian": "Chrs",
    "cirth": "Cirt",
    "codeforinheritedscript": "Zinh",
    "codeforuncodedscript": "Zzzz",
    "codeforundeterminedscript": "Zyyy",
    "codeforunwrittendocuments": "Zxxx",
    "coptic": "Copt",
    "cuneiform": "Xsux",
    "cypriotsyllabary": "Cprt",
    "cyrillic": "Cyrl",
    "deseret": "Dsrt",
    "devanagari": "Deva",
    "divesakuru": "Diak",
    "dogra": "Dogr",
    "duployanshorthand": "Dupl",
    "duployanstenography": "Dupl",
    "egyptiandemotic": "Egyd",
    "egyptianhieratic": "Egyh",
    "egyptianhieroglyphs": "Egyp",
    "elbasan": "Elba",
    "elymaic": "Elym",
    "end": "Qabx",
    "ethiopic": "Ethi",
    "etruscan": "Ital",
    "fraser": "Lisu",
    "garay": "Gara",
    "georgian": "Geor",
    "glagolitic": "Glag",
    "gothic": "Goth",
    "grantha": "Gran",
    "greek": "Grek",
    "gujarati": "Gujr",
    "gunjalagondi": "Gong",
    "gurmukhi": "Guru",
    "gurungkhema": "Gukh",
    "han": "Hani",
    "hangeul": "Hang",
    "hangul": "Hang",
    "hanifirohingya": "Rohg",
    "hanja": "Hani",
    "hanunoo": "Hano",
    "hanzi": "Hani",
    "harappan": "Inds",
    "hatran": "Hatr",
    "hebrew": "Hebr",
    "hiragana": "Hira",
    "hittitehieroglyphs": "Hluw",
    "horizontalsquarescript": "Zanb",
    "hungarianrunic": "Hung",
    "imperialaramaic": "Armi",
    "indus": "Inds",
    "inscriptionalpahlavi": "Phli",
    "inscriptionalparthian": "Prti",
    "javanese": "Java",
    "jurchen": "Jurc",
    "kaganga": "Rjng",
    "kaithi": "Kthi",
    "kanji": "Hani",
    "kannada": "Knda",
    "katakana": "Kana",
    "kawi": "Kawi",
    "kayahli": "Kali",
    "kharoshthi": "Khar",
    "khitanlargescript": "Kitl",
    "khitansmallscript": "Kits",
    "khmer": "Khmr",
    "khojki": "Khoj",
    "khudawadi": "Sind",
    "khutsuri": "Geok",
    "kiratrai": "Krai",
    "klingon": "Piqd",
    "klipiqad": "Piqd",
    "kpelle": "Kpel",
    "lanna": "Lana",
    "lao": "Laoo",
    "latin": "Latn",
    "leke": "Leke",
    "lepcha": "Lepc",
    "limbu": "Limb",
    "lineara": "Lina",
    "linearb": "Linb",
    "lisu": "Lisu",
    "loma": "Loma",
    "luwianhieroglyphs": "Hluw",
    "lycian": "Lyci",
    "lydian": "Lydi",
    "mahajani": "Mahj",
    "makasar": "Maka",
    "malayalam": "Mlym",
    "mandaean": "Mand",
    "mandaic": "Mand",
    "manichaean": "Mani",
    "marchen": "Marc",
    "masaramgondi": "Gonm",
    "mathematicalnotation": "Zmth",
    "mayanhieroglyphs": "Maya",
    "medefaidrin": "Medf",
    "meetei": "Mtei",
    "meiteimayek": "Mtei",
    "meithei": "Mtei",
    "mendekikakui": "Mend",
    "meroiticcursive": "Merc",
    "meroitichieroglyphs": "Mero",
    "miao": "Plrd",
    "mkhedruliandmtavruli": "Geor",
    "modi": "Modi",
    "mongolian": "Mong",
    "moon": "Moon",
    "mooncode": "Moon",
    "moonscript": "Moon",
    "moontype": "Moon",
    "mormon": "Dsrt",
    "mro": "Mroo",
    "mru": "Mroo",
    "multani": "Mult",
    "myanmar": "Mymr",
    "nabataean": "Nbat",
    "nagari": "Deva",
    "nagmundari": "Nagm",
    "nakhigeba": "Nkgb",
    "nakhitomba": "Nkdb",
    "nandinagari": "Nand",
    "naxidongba": "Nkdb",
    "naxigeba": "Nkgb",
    "nepalalipi": "Newa",
    "newa": "Newa",
    "newar": "Newa",
    "newari": "Newa",
    "newtailue": "Talu",
    "nushu": "Nshu",
    "nyiakengpuachuehmong": "Hmnp",
    "oberiokaime": "Medf",
    "odia": "Orya",
    "ogham": "Ogam",
    "ol": "Olck",
    "olchiki": "Olck",
    "oldhungarian": "Hung",
    "olditalic": "Ital",
    "oldnortharabian": "Narb",
    "oldpermic": "Perm",
    "oldpersian": "Xpeo",
    "oldsogdian": "Sogo",
    "oldsoutharabian": "Sarb",
    "oldturkic": "Orkh",
    "olduyghur": "Ougr",
    "olonal": "Onao",
    "oriya": "Orya",
    "orkhonrunic": "Orkh",
    "osage": "Osge",
    "oscan": "Ital",
    "osmanya": "Osma",
    "pahawhhmong": "Hmng",
    "palmyrene": "Palm",
    "paucinhau": "Pauc",
    "phoenician": "Phnx",
    "pollard": "Plrd",
    "psalterpahlavi": "Phlp",
    "ranjana": "Ranj",
    "redjang": "Rjng",
    "rejang": "Rjng",
    "reservedforprivateuse": "Qabx",
    "rong": "Lepc",
    "rongorongo": "Roro",
    "runic": "Runr",
    "samaritan": "Samr",
    "santali": "Olck",
    "sarada": "Shrd",
    "sarati": "Sara",
    "saurashtra": "Saur",
    "sharada": "Shrd",
    "shavian": "Shaw",
    "shaw": "Shaw",
    "shuishu": "Shui",
    "siddham": "Sidd",
    "siddhamatrka": "Sidd",
    "sidetic": "Sidt",
    "signwriting": "Sgnw",
    "sindhi": "Sind",
    "sinhala": "Sinh",
    "sogdian": "Sogd",
    "sorasompeng": "Sora",
    "soyombo": "Soyo",
    "start": "Qaaa",
    "sundanese": "Sund",
    "sunuwar": "Sunu",
    "sylotinagri": "Sylo",
    "symbols": "Zsym",
    "syriac": "Syrc",
    "tagalog": "Tglg",
    "tagbanwa": "Tagb",
    "taiahom": "Ahom",
    "taile": "Tale",
    "taitham": "Lana",
    "taiviet": "Tavt",
    "taiyo": "Tayo",
    "takri": "Takr",
    "tamil": "Taml",
    "tangsa": "Tnsa",
    "tangut": "Tang",
    "tankri": "Takr",
    "telugu": "Telu",
    "tengwar": "Teng",
    "thaana": "Thaa",
    "thai": "Thai",
    "tibetan": "Tibt",
    "tifinagh": "Tfng",
    "tirhuta": "Tirh",
    "todhri": "Todr",
    "tolongsiki": "Tols",
    "toto": "Toto",
    "ugaritic": "Ugar",
    "unifiedcanadianaboriginalsyllabics": "Cans",
    "vai": "Vaii",
    "varangkshiti": "Wara",
    "visiblespeech": "Visp",
    "vithkuqi": "Vith",
    "wancho": "Wcho",
    "warangciti": "Wara",
    "woleai": "Wole",
    "xewteedorboljinbicig": "Zanb",
    "yezidi": "Yezi",
    "yi": "Yiii",
    "zanabazarindorboljinuseg": "Zanb",
    "zanabazarsquare": "Zanb"
};
